import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OrganizationProject } from 'app/fs/res/finance/model/project/project-classes';
import {
    HisBaseGlobalsService
} from 'hisng';
import { indexOf } from 'lodash';

@Component( {
    selector: 'res-additional-internal-organization-edit',
    templateUrl: './additional-internal-organization-edit.component.html'
} )
export class AdditionalInternalOrganizationEditComponent {
    public informationDialogVisibility = false;
    public currentOrg: OrganizationProject;

    @Input() informationDdKey: string;
    @Input() projectOrganizationArray: OrganizationProject[] = [];
    @Output() projectOrganizationArrayChange: EventEmitter<OrganizationProject[]> = new EventEmitter();

    constructor(
        public hisBaseGlobalsService: HisBaseGlobalsService ) {
    }

    deleteOrg( org: OrganizationProject ) {
        this.projectOrganizationArray.splice( indexOf( this.projectOrganizationArray, org ), 1 );
        this.projectOrganizationArrayChange.emit( this.projectOrganizationArray );
    }

    showInformationPopUp( org: OrganizationProject ) {
        this.currentOrg = org;
        this.informationDialogVisibility = !this.informationDialogVisibility;
    }

    get isInformationHidden() {
        if ( this.hisBaseGlobalsService.getDd( this.informationDdKey ) ) {
            return this.hisBaseGlobalsService.getDd( this.informationDdKey ).hidden;
        } else {
            return true;
        }
    }
}
